/* eslint-disable */

import React from "react";
import {
  InputCustomChangeEventHandler,
  PicklistFieldConfig
} from "../../types";
import useT from "../../hooks/useT";
import InputSelectCustom, {
  ReactSelectOption,
  InputSelectCustomProps
} from "../InputSelectCustom";

import { get } from "../../utils/helpers";
import useAppState from "../../hooks/useAppState";

export interface InputCustomPicklistProps
  extends Pick<
    InputSelectCustomProps,
    Exclude<keyof InputSelectCustomProps, "options" | "onChange">
  > {
  /**
   * If the input is optional, you can show a "prefer not to say" option which will
   * set the value to an empty string.
   *
   * @default false
   */
  showEmptyOption?: boolean;
  /** Event handler to publish changes to the controlling parent component. */
  onChange: InputCustomChangeEventHandler;
}

const loadOptionsFromConfig = (
  name: string | undefined,
  lang: string | undefined
) => {
  if (!name) {
    return [];
  }
  const [appState] = useAppState();
  const config = appState.config;
  const picklistValues = get(config, "customise.fields.picklistValues");

  if (picklistValues) {
    let options: any = [];
    picklistValues
      .filter((valuesConfig: PicklistFieldConfig) => valuesConfig.name === name)
      .forEach((valuesConfig: PicklistFieldConfig) => {
        if (valuesConfig.options) {
          options = valuesConfig.options.map((option: ReactSelectOption) => ({
            ...option
          }));
        } else if (valuesConfig.values) {
          options = valuesConfig.values.map((value: string) => ({
            label: value,
            value: value
          }));
        }
      });
    if (options) {
      // add translator module
      const { t, i18n } = useT();
      const lng = lang || i18n.language;

      options.forEach((option: any) => {
        //option.label = t(`customer.fields.${name}.options.${option.value}`, {
        option.label = t(option.label, {
          lng,
          defaultValue: option.label
        });
      });
      return options;
    }
  }
  return [];
};

export default function InputCustomPicklist({
  searchable = false,
  clearable = true,
  showEmptyOption = false,
  ...props
}: InputCustomPicklistProps) {
  const options = loadOptionsFromConfig(props.name, props.lang);

  // add translator module
  const { t, i18n } = useT();
  const lng = props.lang || i18n.language;

  return (
    <InputSelectCustom
      {...props}
      options={options}
      disabled={props.disabled}
      clearable={clearable}
      searchable={searchable}
    />
  );
}
